import React from "react";
import { Localize } from "components/service";


const isDefined = (value) => value !== null && value !== undefined;

const StaffManagementWorkersField = ({ count, onSiteCount }) => (
    isDefined(count) ?
        <span className="staff-management-list__workers">
            { count }
            { isDefined(onSiteCount) &&
                <span className="staff-management-list__on-site">
                    ({ onSiteCount } <Localize>STAFF_MANAGEMENT.Text_OnSite</Localize>)
                </span>
            }
        </span> :
        <span>&mdash;</span>
);

export default StaffManagementWorkersField;
